import BaseAPIService from '../base/base-api-service';
import CreditCardIframeModel from 'src/model/creditCardIframe.model';

class AddCreditCardService extends BaseAPIService<CreditCardIframeModel> {
  public endpoint: string = '/cartapp/v1/creditcard/savedCards/add';

  constructor() {
    super(CreditCardIframeModel);
  }

  public getCreditCardIframeUrlAndSessionId(): Promise<CreditCardIframeModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      url: this.endpoint
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  }

  public addCreditCard(sessionID: string) {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'POST',
      url: this.endpoint,
      data: {
        sessionID
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  }
}

const addCreditCardServiceInstance = new AddCreditCardService();
Object.freeze(addCreditCardServiceInstance);

export default addCreditCardServiceInstance;
